import React, { createContext, useEffect, useState } from "react";

export interface TabContextProps {
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  currentTab?: HTMLDivElement;
  setCurrentTab: (tab: HTMLDivElement) => void;
}

export const TabContext = createContext({} as TabContextProps);

export interface TabProviderProps {
  defaultIndex?: number;
  onChange?: (v: number) => void;

  children?: React.ReactNode;
}

/**
 * @deprecated TabUI instead
 */
export const TabProvider = ({
  defaultIndex = 0,
  children,
  onChange,
}: TabProviderProps) => {
  const cache = React.useRef<number | null>(defaultIndex);
  const [index, setIndex] = useState(defaultIndex);
  const [tab, setTab] = useState<HTMLDivElement>();
  useEffect(() => {
    if (cache.current === index) {
      cache.current = null;
      return;
    }
    if (onChange) {
      onChange(index);
    }
  }, [index, onChange]);
  return (
    <TabContext.Provider
      value={{
        currentIndex: index,
        setCurrentIndex: setIndex,
        currentTab: tab,
        setCurrentTab: setTab,
      }}
    >
      <>{children}</>
    </TabContext.Provider>
  );
};
